module.exports = __webpack_public_path__ + "img/n2.79a19742.png";